module.exports = __webpack_public_path__ + "img/item-6(1920)new.b5a35c3f.jpg";